module.exports = __webpack_public_path__ + "static/img/img_main.cce4549c.png";